import { z } from 'zod';
export const storyKindSchema = z.enum(['STATIC', 'DAY', 'REPORT', 'POLL']);
export const storyProjectTypeSchema = z.enum(['RENOVATION', 'FINANCE']).nullable();
// ─── Опрос (POLL) ──────────────────────────────────────────────────────────
/** Вариант ответа в опросе. */
export const pollOptionSchema = z.object({
    id: z.string().min(1),
    label: z.string().min(1).max(120),
    emoji: z.string().max(8).nullable().optional(),
});
/** Один вопрос опроса с вариантами ответа. */
export const pollQuestionSchema = z.object({
    id: z.string().min(1),
    question: z.string().min(1).max(280),
    options: z.array(pollOptionSchema).min(2).max(6),
});
/** Конфиг истории-опроса (хранится в Story.config). Несколько вопросов подряд. */
export const pollConfigSchema = z.object({
    questions: z.array(pollQuestionSchema).min(1).max(10),
});
/** Конфиг кастомных типов историй. Пока только опрос. */
export const storyConfigSchema = pollConfigSchema.nullable();
// ─── Каталог историй (дашборд) ───────────────────────────────────────────────
/** Каталожная запись истории, отдаётся дашборду (только enabled). */
export const storySchema = z.object({
    key: z.string(),
    kind: storyKindSchema,
    projectType: storyProjectTypeSchema,
    titleKey: z.string(),
    descKey: z.string().nullable(),
    emoji: z.string().nullable(),
    bg: z.string().nullable(),
    config: storyConfigSchema,
    sortOrder: z.number(),
});
/** POST /stories/seen — отметить истории просмотренными. */
export const storySeenRequestSchema = z.object({
    keys: z.array(z.string()).min(1),
    projectId: z.string().optional(),
});
/** GET /stories/seen — список просмотренных ключей. */
export const storySeenResponseSchema = z.object({
    keys: z.array(z.string()),
});
/** POST /stories/:key/vote — ответить на один вопрос опроса. */
export const storyPollVoteRequestSchema = z.object({
    questionId: z.string().min(1),
    optionId: z.string().min(1),
    projectId: z.string().optional(),
});
/** GET /stories/votes — ответы пользователя по вопросам опросов. */
export const storyVoteAnswerSchema = z.object({
    storyKey: z.string(),
    questionId: z.string(),
    optionId: z.string(),
});
export const storyVotesResponseSchema = z.object({
    answers: z.array(storyVoteAnswerSchema),
});
/** POST /ops/stories — создать историю (в т.ч. опрос). */
export const createStorySchema = z.object({
    key: z.string().min(1).max(64).regex(/^[a-z0-9_]+$/, 'только латиница, цифры и _'),
    kind: storyKindSchema,
    projectType: storyProjectTypeSchema.default(null),
    titleKey: z.string().min(1),
    descKey: z.string().nullable().optional(),
    emoji: z.string().max(8).nullable().optional(),
    bg: z.string().max(200).nullable().optional(),
    config: storyConfigSchema.optional(),
    enabled: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
/** PATCH /ops/stories/:id */
export const updateStorySchema = z.object({
    titleKey: z.string().min(1).optional(),
    descKey: z.string().nullable().optional(),
    emoji: z.string().max(8).nullable().optional(),
    bg: z.string().max(200).nullable().optional(),
    projectType: storyProjectTypeSchema.optional(),
    config: storyConfigSchema.optional(),
    enabled: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
//# sourceMappingURL=story.js.map